import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appOnKeyEnterEvent]',
    standalone: true,
})
export class OnKeyEnterEventDirective {
    @Output() enter: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private el: ElementRef) {}

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.enter.emit(true);
        }
    }
}
